import { MAX_UPLOAD_FILE_SIZE, MAX_UPLOAD_VIDEO_FILE_SIZE } from "../constants/ai-question";
/**
 * 根据传入秒数计算出时分秒
 * @param second 秒数
 * @param convertText 是否需要转换为文本，默认为true
 * @returns [时, 分, 秒]
 */
export var getSecondToTime = function (second, convertText) {
    if (convertText === void 0) { convertText = true; }
    if (second > 0) {
        var h = parseInt("".concat((second / 60 / 60) % 24));
        var m = parseInt("".concat((second / 60) % 60));
        var s = parseInt("".concat(second % 60));
        var text = "".concat(h > 0 ? h + '小时' : '').concat(m > 0 ? m + '分钟' : '').concat(s > 0 ? s + '秒' : '');
        return convertText ? text : [h, m, s];
    }
    else {
        return convertText ? '0秒' : [0, 0, 0];
    }
};
/**
 * 把非数字的都替换掉，除了数字和.
 * 保证只有出现一个.而没有多个.
 * 保证第一个为数字而不是.
 * 保证.只出现一次，而不能出现两次以上
 * 只能输入两个小数
 * @param value 需要格式化的值
 * @returns 格式化后的值
 */
export var formatNumberDecimal = function (value) {
    return value
        .replace(/[^\d.]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace(/^\./g, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
};
/**
 * 正则验证两位小数
 */
export var decimalReg = /^(([0-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/;
/**
 * 保留两位小数
 * @param value 值
 * @returns 返回保留两位小数的值
 */
export var computeDecimalValue = function (value) { return Math.abs(parseFloat(parseFloat(value.trim()).toFixed(2))); };
/**
 * 生成唯一ID
 * @returns 唯一ID
 */
export var uniqueId = function () {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
};
/** 去掉回车换行-空格 */
export var formatStr = function (str) {
    return str.replace(/[\r\n]/g, '').replace(/\s/g, '');
};
/**
 * 格式化分值
 * @param score 分数
 * @returns 计算后分数
 */
export var formatScore = function (score) {
    return Math.round(score * 100) / 100;
};
export var formatLowScore = function (num) {
    if (num < 2) {
        return 2;
    }
    return num;
};
/**
 * 关键字高亮
 * @param content 内容
 * @param keyword 关键词
 * @param bgColor 背景色
 * @param tagName 标签名
 */
export var highlighKeywords = function (content, keyword, bgColor, tagName) {
    if (tagName === void 0) { tagName = 'span'; }
    if (!content || !keyword || !bgColor) {
        return content;
    }
    var newContent = content.toLowerCase();
    var newKeyword = keyword.toLowerCase();
    var indexof = newContent.indexOf(newKeyword);
    var text = indexof > -1 ? content.substr(indexof, keyword.length) : '';
    var value = "<".concat(tagName, " style=\"background: ").concat(bgColor, ";\">").concat(text, "</").concat(tagName, ">");
    var regS = new RegExp(keyword, 'gi');
    return content.replace(regS, value);
};
/**
 * 根据数组对象的某个字段去重
 * @param arr 数组对象
 * @param key 字段名称
 * @returns 去重后数组
 */
export var arrayUnique = function (arr, key) {
    var map = new Map();
    return arr.filter(function (item) { return !map.has(item[key]) && map.set(item[key], 1); });
};
export var isExceedMaxFileSize = function (size) { return size > MAX_UPLOAD_FILE_SIZE; };
export var isExceedMaxVideoFileSize = function (size) { return size > MAX_UPLOAD_VIDEO_FILE_SIZE; };
